/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const FileDropZoneImage = () => {
  return (
    <svg width="340" height="215" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path
          d="m263.968 221.697-54.165-31.186-78.926 9.167-1.502 20.377 50.883 55.807h57.653l.755-8.715s20.723 2.921 31.63-7.723 0-14.567 0-14.567 1.067-11.662-3.858-11.662c-4.924 0-2.47-11.498-2.47-11.498zM36.266 136.304l58.638.041-9.848-59.91-32.007-2.462-16.783 62.331z"
          fill="#fff"
        />
        <path d="M129.759 207.441 90.136 375.822h75.249l10.71-107.149" fill="#fff" />
        <path
          d="M129.759 207.441 90.136 375.822h75.249l10.71-107.149"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M231.034 111.544c-13.131-2.265-20.829.82-26.886 2.33-14.297 3.636-35.733 2.241-56.004-2.297-20.821-4.654-44.219.894-53.46 23.914-6.565 16.455 43.497 16.611 43.497 16.611l-8.396 53.911h81.577L208.5 217l65.472 13.839a215.03 215.03 0 0 0 19.951-50.686c10.809-44.038-38.572-64.432-62.889-68.609zm-10.743 79.681-4.752-33.247 18.835 10.784-14.083 22.463z"
          fill="#006CFD"
        />
        <path
          d="m244.37 174.433-28.831-16.454M234.373 168.762l-18.835 30.079s-13.656 24.62-7.386 42.815c6.057 17.497 26.262 32.302 50.464 24.9 24.202-7.403 15.478-21.338 10.768-22.11-4.711-.771-11.441 6.632-11.441 6.632"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M162.612 96.542c-14.107 3.488-19.696-4.752-20.886-10.48a16.662 16.662 0 0 1 3.447-13.657s-5.614-3.717-2.249-13.13c2.232-6.23 9.783-7.387 9.783-7.387 1.066-5.564 5.744-3.414 5.744-3.414s.682-5.45 6.016-6.705c4.842-1.14 7.386 1.28 7.386 1.28s.928-4.234 6.164-4.234a6.267 6.267 0 0 1 6.368 4.735s4.58-1.871 8.535-.755c10.628 2.995 9.52 13.582 9.52 13.582s2.462-1.034 4.022.386c2.88 2.593-.731 6.048-.731 6.048s7.83-1.403 9.307 4.3c1.477 5.705-5.671 8.052-5.671 8.052s3.841.238 4.235 5.08c.459 5.745-5.811 7.066-5.811 7.066s2.323 2.807-.197 6.87c-2.092 3.38-8.518 3.577-9.848 1.173"
          fill="#031D40"
        />
        <path
          d="M162.612 96.542c-14.107 3.488-19.696-4.752-20.886-10.48a16.662 16.662 0 0 1 3.447-13.657s-5.614-3.717-2.249-13.13c2.232-6.23 9.783-7.387 9.783-7.387 1.066-5.564 5.744-3.414 5.744-3.414s.682-5.45 6.016-6.705c4.842-1.14 7.386 1.28 7.386 1.28s.928-4.234 6.164-4.234a6.267 6.267 0 0 1 6.368 4.735s4.58-1.871 8.535-.755c10.628 2.995 9.52 13.582 9.52 13.582s2.462-1.034 4.022.386c2.88 2.593-.731 6.048-.731 6.048s7.83-1.403 9.307 4.3c1.477 5.705-5.671 8.052-5.671 8.052s3.841.238 4.235 5.08c.459 5.745-5.811 7.066-5.811 7.066s2.323 2.807-.197 6.87c-2.092 3.38-8.518 3.577-9.848 1.173"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M184.213 94.4s-9.299 5.482-20.575-.608a20.516 20.516 0 0 1-10.341-14.436 30.278 30.278 0 0 1 .304-10.053c2.183-13.008 9.799-19.606 22.824-18.523 19.885 1.641 19.36 20.517 19.36 20.517s5.26-.574 5.744 3.283c.657 5.22-4.489 5.942-4.489 5.942l4.965 32.433s-5.744 4.104-27.082 3.283c-14.453-.558-22.98-4.103-22.98-4.103s1.494-21.666 1.765-30.875"
          fill="#fff"
        />
        <path
          d="M184.213 94.4s-9.298 5.482-20.575-.608a20.526 20.526 0 0 1-10.34-14.436 30.252 30.252 0 0 1 .303-10.053c2.183-13.008 9.799-19.606 22.824-18.523 19.885 1.641 19.36 20.517 19.36 20.517s5.26-.574 5.745 3.283c.656 5.22-4.49 5.942-4.49 5.942l5.327 32.212s-9.849 9.389-27.264 8.872c-14.452-.427-23.463-7.305-23.463-7.305s1.789-23.89 2.06-33.098"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M172.772 78.88s-5.556 1.076-5.794-.566c-.238-1.641 3.66-5.802 3.939-6.483l.353-3.759M165.846 85.413c.772 1.05 2.167 2.052 4.678 1.871a5.106 5.106 0 0 0 4.416-2.536"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.381 40.201c.689 3.816-3.365 5.047-3.365 5.047s7.05 3.685 4.727 9.102c-2.322 5.416-9.413 2.897-9.413 2.897s2.889 2.544.238 6.607c-3.16 4.833-8.921 2.027-8.921 2.027"
          fill="#031D40"
        />
        <path
          d="M167.381 40.201c.689 3.816-3.365 5.047-3.365 5.047s7.05 3.685 4.727 9.102c-2.322 5.416-9.413 2.897-9.413 2.897s2.889 2.544.238 6.607c-3.16 4.833-8.921 2.027-8.921 2.027"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M169.762 50.304c1.387 1.641 3.939.895 3.939.895s-3.02 4.546.657 7.017c2.265 1.518 4.924-1.035 4.924-1.035s-2.29 5.59 2.175 8.692c3.373 2.347 7.386.18 7.386.18a6.271 6.271 0 0 0 5.745 5.499c5.187.656 6.647-3.43 6.647-3.43l-11.284-19.295"
          fill="#031D40"
        />
        <path
          d="M169.762 50.304c1.387 1.641 3.939.895 3.939.895s-3.02 4.546.657 7.017c2.265 1.518 4.924-1.035 4.924-1.035s-2.29 5.59 2.175 8.692c3.373 2.347 7.386.18 7.386.18a6.271 6.271 0 0 0 5.745 5.499c5.187.656 6.647-3.43 6.647-3.43l-11.284-19.295"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M89.514 69.22s11.85-3.537 15.232 1.543c3.381 5.08-4.334 8.527-12.023 8.97" fill="#fff" />
        <path
          d="M89.514 69.22s11.85-3.537 15.232 1.543c3.381 5.08-4.334 8.527-12.023 8.97"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M36.227 136.304s7.788-68.88 17.956-71.228c8.593-1.986 5.097 17.399 5.097 17.399" fill="#fff" />
        <path
          d="M36.227 136.304s7.788-68.88 17.956-71.228c8.593-1.986 5.097 17.399 5.097 17.399"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m117.721 86.488-81.979 22.758s-5.687.18-7.255-4.514c-2.002-6.008 2.815-8.19 2.815-8.19l82.332-22.38"
          fill="#fff"
        />
        <path
          d="m117.721 86.488-81.979 22.758s-5.687.18-7.255-4.514c-2.002-6.008 2.815-8.19 2.815-8.19l82.332-22.38"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.798 70.345s5.244-6.86 12.154-2.667c5.097 3.094 9.373 14.772 4.49 18.055-5.852 3.948-11.104-4.604-11.104-4.604"
          fill="#fff"
        />
        <path
          d="M73.798 70.345s5.244-6.86 12.154-2.667c5.097 3.094 9.373 14.772 4.49 18.055-5.852 3.948-11.104-4.604-11.104-4.604"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.675 76.024a45.77 45.77 0 1 0 88.728-22.508 45.77 45.77 0 0 0-88.728 22.508zm35.881-45.597a35.371 35.371 0 1 1-25.589 42.988 35.369 35.369 0 0 1 25.589-42.955v-.033z"
          fill="#fff"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.535 75.294s2.274-5.31 9.463-5.342c7.19-.033 10.603 11.49 9.34 14.936-1.264 3.447-7.51 5.564-12.171-2.798"
          fill="#fff"
        />
        <path
          d="M60.535 75.294s2.274-5.31 9.463-5.342c7.19-.033 10.603 11.49 9.34 14.936-1.264 3.447-7.51 5.564-12.171-2.798"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M137.992 145.783c-11.489 70.013-82.159 77.588-98.286 26.361-7.755-24.621-3.881-40.436-3.881-40.436l60.6-4.341 41.567 24.982"
          fill="#006CFD"
        />
        <path
          d="M85.278 95.984c3.283.262 6.73-3.612 9.184-4.678 7.164-3.11 12.015 2.815 7.993 8.116-3.627 4.793-7.944 9.627-7.681 16.652a169.319 169.319 0 0 0 2.757 25.121"
          fill="#fff"
        />
        <path
          d="M85.278 95.984c3.283.262 6.73-3.612 9.184-4.678 7.164-3.11 12.015 2.815 7.993 8.116-3.627 4.793-7.944 9.627-7.681 16.652a169.319 169.319 0 0 0 2.757 25.121"
          stroke="#031D40"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M164.369 71.306a2.088 2.088 0 0 1-.821-.18 2.336 2.336 0 0 1-1.329-1.97 1.987 1.987 0 0 1 .73-1.748 2.243 2.243 0 0 1 2.282-.362 2.2 2.2 0 0 1 1.354 1.781 2.233 2.233 0 0 1-.911 2.069 2.166 2.166 0 0 1-1.305.41zM178.329 72.167a2.091 2.091 0 0 1-.821-.18 2.331 2.331 0 0 1-1.33-1.97 1.982 1.982 0 0 1 .731-1.757 2.247 2.247 0 0 1 2.281-.36 2.195 2.195 0 0 1 1.354 1.78 2.232 2.232 0 0 1-.91 2.068 2.15 2.15 0 0 1-1.305.419z"
          fill="#031D40"
        />
        <path
          d="M340 214H0"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h340v215H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
